import React from "react";
import BarraSupDent from "../commons/BarraSupDent.jsx";
import firebasemanager from "../model/Firebase/FirebaseManager";
import Dent from "./Component/Dent.js";
import firebaseManager from "../model/Firebase/FirebaseManager";

class Dent_information extends React.Component {
  // fake authentication Promise
  authenticate() {
    return new Promise((resolve) => setTimeout(resolve, 2000)); // 2 seconds
  }

  componentDidMount() {
    this.authenticate().then(() => {
      const ele = document.getElementById("ipl-progress-indicator");
      if (ele) {
        // fade out
        ele.classList.add("available");
        setTimeout(() => {
          // remove from DOM
          ele.outerHTML = "";
        }, 2000);
      }
    });
  }

  constructor(props) {
    super(props);
    this.getdentSelected = this.getdentSelected.bind(this);
    this.chargePriceDentSelect = this.chargePriceDentSelect.bind(this);
  }
  getdentSelected = () => {
    firebasemanager.dentSelect();
  };

  handlePrice(e) {
    sessionStorage.setItem("dentPrice", e.target.value);
  }

  chargePriceDentSelect() {
    firebaseManager.confirmPriceDentSelected(
      this.successPriceCallback,
      this.failPriceCallback
    );
  }

  successPriceCallback = () => {
    window.location = "/dashboard";
  };

  failPriceCallback(error) {
    alert(error.mesagge);
  }

  render() {
    return (
      <React.Fragment>
        <BarraSupDent />
        <div className="text-center">
          <div className=" mt-5 pb-5 contenedor-confirm">
            <Dent />
          </div>
        </div>
      </React.Fragment>
    );
  }
}
export default Dent_information;